import _, { size } from 'lodash';
import moment from 'moment';
import { IMAGES } from 'src/appConfig/images';
import { FileData, FileType } from 'src/dataFactory/depositionFactory';

/**
 * Get file icon
 * @param {string} fileExtention
 */
export const getFileIcon = (fileExtention: string) => {
  switch (fileExtention.toLowerCase()) {
    case 'jpg':
    case 'jpeg':
      return IMAGES.iconFileJpg;
    case 'png':
      return IMAGES.iconFilePng;
    case 'pdf':
      return IMAGES.iconFilePdf;
    case 'doc':
    case 'docx':
      return IMAGES.iconFileDoc;
    case 'ppt':
    case 'pptx':
      return IMAGES.iconFilePpt;
    case 'xls':
    case 'xlsx':
      return IMAGES.iconFileXls;
    case 'txt':
      return IMAGES.iconFileTxt;
    case 'odt':
      return IMAGES.iconFileOdt;
    case 'mp3':
      return IMAGES.iconFileMp3;
    case 'm4a':
      return IMAGES.iconFileM4a;
    case 'wav':
      return IMAGES.iconFileWav;
    case 'mp4':
      return IMAGES.iconFileMp4;
    case 'm4v':
      return IMAGES.iconFileM4v;
    case 'mpg':
      return IMAGES.iconFileMpg;
    case 'wmv':
      return IMAGES.iconFileWmv;
    case 'mov':
      return IMAGES.iconFileMov;
    case 'avi':
      return IMAGES.iconFileAvi;
    case 'swf':
      return IMAGES.iconFileSwf;
    case 'zip':
      return IMAGES.iconFileZip;
    case 'rar':
      return IMAGES.iconFileRar;
    case '7z':
      return IMAGES.iconFile7zi;
    case 'ptx':
      return IMAGES.iconFilePtx;
    default:
      return IMAGES.iconFileRaw;
  }
};

export const modifyFiles = (existingFiles: any, payload: { files: any[]; id: any; type: FileType }) => {
  let fileToUpload = {};

  for (let i = 0; i < payload.files.length; i++) {
    const id = size(existingFiles) + i + 1;

    fileToUpload = {
      ...fileToUpload,
      [id]: {
        id,
        file: payload.files[i],
        progress: 0,
        depositionId: payload.id,
        type: payload.type,
      },
    };
  }

  return fileToUpload;
};

export const getUploadErrorMessage = (error: any) => {
  if (error?.code && error.code === 'E__INVALID_PARAMETER') {
    return 'File is not supported';
  }
  if (error?.errorId && error.errorId === 'E__INVALID_OPERATION_ERROR') {
    return 'Cannot upload a duplicate file name';
  }
  return 'File is failed to upload';
};

export const comparerFiles = (otherArray: FileData[]) => {
  return function (current: FileData) {
    return (
      otherArray.filter(function (file: FileData) {
        return file.id === current.id;
      }).length === 0
    );
  };
};

// option : 1 | 2 | 3 | 4 | 5
// ordered:Name(A-Z)|Name(Z-A)}|UpdateTime(new->old)|UpdateTime(old->new)|Order
export const getOrderedFiles = (files: FileData[], option: number) => {
  var orderedFiles = files;
  switch (option) {
    case 1:
      return _.orderBy(orderedFiles, [file => file.name.toLowerCase()], ['asc']);
    case 2:
      return _.orderBy(orderedFiles, [file => file.name.toLowerCase()], ['desc']);
    case 3:
      return _.orderBy(orderedFiles, [file => moment(file.updatedDate)], ['asc']);
    case 4:
      return _.orderBy(orderedFiles, [file => moment(file.updatedDate)], ['desc']);
    case 5:
      return _.orderBy(orderedFiles, ['order'], ['asc']);
    default:
      return orderedFiles;
  }
};

export const getFileType = (file: File) => {
  if (!!file.type) return file.type;
  if (file.name.includes('.rar')) return 'application/x-rar-compressed';
  if (file.name.includes('.7z')) return 'application/x-7z-compressed';
  return 'image/png';
};

export const bytesToSize = (bytes: number) => {
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 Byte';
  var i = Math.floor(Math.log(bytes) / Math.log(1024));
  return Number(bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
};

export const isSelectedAll = (files: FileData[]) => {
  const unSelectedFiles = files.filter(f => !f.isSelected);
  return unSelectedFiles.length === 0;
};

export const isSelected = (files: FileData[]) => {
  return files.some(f => f.isSelected);
};
